// @flow
import { useEffect } from "react";
import { Alert } from "react-native";
import { useDispatch } from "react-redux";
import { clearError } from "../actions";
import { i18n } from "../config/i18n";

const alertError = (error: string, onPress?: () => void, title?: string) => {
  Alert.alert(title || i18n.t("checkoutScreen.checkoutError"), error, [
    {
      text: i18n.t("orderScreen.cancelDialog.dismiss"),
      style: "cancel",
      onPress,
    },
  ]);
};
export const useErrorHandler = (
  error: string | string[],
  onPress?: () => void,
  title?: string,
): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (error && error.length > 0) {
      const formattedError = Array.isArray(error)
        ? error.reduce(
            (result, v, i) => result.concat(i === 0 ? v : `\n${v}`),
            "",
          )
        : error;
      alertError(formattedError, onPress, title);
      dispatch(clearError());
    }
  }, [error, dispatch, onPress, title]);
};
